/**
 * SÜRÜM TAZELEME — yeni service worker devralınca sayfayı yenile.
 *
 * ⚠️ NEDEN GEREKLİ: `sw.ts` içinde `skipWaiting()` + `clientsClaim()` var, yani
 *    yeni service worker ANINDA devralıyor. Ama AÇIK OLAN SAYFA eski JS'i
 *    çalıştırmaya devam ediyor — ve `registerSW.js` yalnızca kayıt yapıyor,
 *    tazeleme mantığı içermiyor (`virtual:pwa-register` içe aktarılmadığı için
 *    vite-plugin-pwa asgari betiği üretiyor).
 *
 *    Sonuç: deploy'dan sonra kullanıcı ESKİ arayüzü görmeye devam ediyor ve bu
 *    sessiz bir hata değil, YANILTICI bir hata: eski JS yeni API'ye soruyor,
 *    olmayan alanları okuyup "—" gösteriyor. Sahada iki kez yaşandı
 *    (30.07 bildirim ikonu, 02.08 nihai boyut).
 *
 * ⚠️ SAYFA OTOMATİK YENİLENİR. Yazılmakta olan bir form varsa girdinin kaybı
 *    mümkün; buna rağmen otomatik tercih edildi çünkü alternatif — kullanıcının
 *    fark etmediği bir uyarı şeridi — tam da yaşanan sorunu tekrar üretir.
 *    Gönderilmiş komutlar zaten çevrimdışı kuyrukta güvende (T1); risk yalnızca
 *    henüz gönderilmemiş yazıdır ve bu yalnızca deploy anında oluşur.
 */

const ANAHTAR = 'mod-erp-yenilendi';

export function guncellemeyiIzle(): void {
  if (!('serviceWorker' in navigator)) return;

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    /*
     * TEK SEFER. `controllerchange` bazı tarayıcılarda arka arkaya tetiklenir;
     * korumasız bırakılırsa sayfa sonsuz döngüye girer ve uygulama açılmaz.
     * İşaret oturum boyunca tutuluyor — sekme kapanınca sıfırlanır.
     */
    if (sessionStorage.getItem(ANAHTAR)) return;
    sessionStorage.setItem(ANAHTAR, '1');
    window.location.reload();
  });

  /*
   * Sekmeye dönüldüğünde güncelleme kontrolü. Saha telefonu günlerce açık
   * kalabiliyor; yalnız ilk yüklemede bakmak, o cihazın haftalarca eski
   * sürümde kalması demek.
   */
  const kontrol = () => {
    if (document.visibilityState === 'visible') {
      void navigator.serviceWorker.getRegistration().then((r) => r?.update());
    }
  };
  document.addEventListener('visibilitychange', kontrol);
}
